import api, { CrudRestApi } from '../api';
import { Point } from 'models/mission/Point';

const apiUrl = 'drone-missions';

const rest = CrudRestApi(apiUrl, Point);

const setMission = async data => {
    return api.post(`${apiUrl}`, { data });
};

const PointMissionService = {
    ...rest,
    setMission,
};

export default PointMissionService;
